import BiMap from 'bimap'
import fromEntries from 'fromentries'
import { ServerTypeConfigJSON } from '../Types/Types'
import Broadworks from './ServerTypeConfig/Broadworks.json'
import Demo from './ServerTypeConfig/Demo.json'
import BroadsoftM6 from './ServerTypeConfig/M6.json'
import Panasonic from './ServerTypeConfig/Panasonic.json'
import Siemens from './ServerTypeConfig/Siemens.json'
import Webex from './ServerTypeConfig/Webex.json'
import Teams from './ServerTypeConfig/Teams.json'

export type ServerTypeFields = typeof Broadworks.fields
export type ServerTypeConfigRecord = { [key: number]: ServerTypeFields }

// All of the available server types that we support for this feature.
export enum AvailableServerTypesNames {
    UNKNOWN = 'Unknown',
    DEMO = 'Simulator',
    M6 = 'BroadSoft M6',
    BROADWORKS = 'BroadSoft BroadWorks',
    SIEMENS = 'Siemens HiPath 3000',
    PANASONIC = 'Panasonic TDA/NCP',
    WEBEX = 'Webex Calling',
    TEAMS = 'MS Teams'
}

// The IDs of the available server types.
export enum AvailableServerTypesID {
    UNKNOWN = -1,
    DEMO = 1,
    M6 = 5,
    BROADWORKS = 7,
    SIEMENS = 15,
    PANASONIC = 20,
    WEBEX = 25,
    TEAMS = 30
}

// BiMap of the available server types.
export const availableServerTypesBiMap: BiMap<string, number> = new BiMap()

availableServerTypesBiMap.push(AvailableServerTypesNames.UNKNOWN, AvailableServerTypesID.UNKNOWN)
availableServerTypesBiMap.push(AvailableServerTypesNames.DEMO, AvailableServerTypesID.DEMO)
availableServerTypesBiMap.push(AvailableServerTypesNames.M6, AvailableServerTypesID.M6)
availableServerTypesBiMap.push(AvailableServerTypesNames.BROADWORKS, AvailableServerTypesID.BROADWORKS)
availableServerTypesBiMap.push(AvailableServerTypesNames.SIEMENS, AvailableServerTypesID.SIEMENS)
availableServerTypesBiMap.push(AvailableServerTypesNames.PANASONIC, AvailableServerTypesID.PANASONIC)
availableServerTypesBiMap.push(AvailableServerTypesNames.WEBEX, AvailableServerTypesID.WEBEX)
availableServerTypesBiMap.push(AvailableServerTypesNames.TEAMS, AvailableServerTypesID.TEAMS)

// Convert between the server returned value and the real value.
export function convertServerType(serverType?: string): Definable<AvailableServerTypesID>
export function convertServerType(
    serverType?: string | number
): Definable<AvailableServerTypesID | AvailableServerTypesNames> {
    if (typeof serverType === 'string') {
        return availableServerTypesBiMap.key(serverType) as AvailableServerTypesID
    }

    if (typeof serverType === 'number') {
        return availableServerTypesBiMap.val(serverType) as AvailableServerTypesNames
    }

    return undefined
}

export const serverTypeConfigArray: ServerTypeConfigJSON<ServerTypeFields>[] = [
    Broadworks,
    Demo,
    BroadsoftM6,
    Panasonic,
    Siemens,
    Webex,
    Teams
]

// Convert the server type config into a map so that we can easily access the fields.
const serverTypeConfig: ServerTypeConfigRecord = fromEntries(
    serverTypeConfigArray.map(({ ID, fields }: ServerTypeConfigJSON<ServerTypeFields>) => [ID, fields])
)

export const getServerTypeConfig = (serverTypeID?: string): ServerTypeFields =>
    serverTypeConfig[convertServerType(serverTypeID) ?? AvailableServerTypesID.UNKNOWN]
